






import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

const namespace: string = 'login';

@Component
export default class FooterBar extends Vue {
  private version = process.env.VUE_APP_VERSION || '0.1.0';
}
